import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NavigationEnd, Router } from '@angular/router';
import { AuthRoleService } from '../../services/auth-role.service';
interface MenuItem {
  icon: string;
  iconType: string;
  label: string;
  route: string;

}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    trigger('slide', [
      state('up', style({ height: 0 })),
      state('down', style({ height: '*' })),
      transition('up <=> down', animate(200))
    ])
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SidebarComponent {
  @Input() isSidebarCollapsed = true;
  @Output() sidebarToggle = new EventEmitter<void>();
  activeRoute: string = '';
  codexAiDiagramGeniusRoute: any = '';

  private currentProjectId: string | null = null;

  constructor(private router: Router,
    private authRoleService: AuthRoleService,
  ) { }
  ngOnInit() {
    this.activeRoute = this.router.url;
    console.log(this.activeRoute);

  }

  ngAfterViewInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = event.urlAfterRedirects;
        console.log('Ruta activa:', this.activeRoute);
        console.log(event);

        this.menuItems = [{
          icon: 'home',
          iconType: 'mat',
          label: 'IO Test',
          route: "/"
        }];

        const baseMatch = this.activeRoute.match(/^.*?\/apps/);
        const appInfos = [
          { label: 'Codex AI DiagramGenius', route: 'codex-ai-diagramGenius' }
        ];

        if (baseMatch) {
          const baseRoute = baseMatch[0];

          appInfos.forEach(app => {
            if (this.activeRoute.includes(`/apps/`)) {
              const appRoute = `${baseRoute}/${app.route}`;
              const alreadyExists = this.menuItems.some(item => item.route === appRoute);

              if (!alreadyExists) {
                this.menuItems.push({
                  icon: `assets/${app.route}.png`,
                  iconType: 'other',
                  label: app.label,
                  route: appRoute
                });
              }
            }
          });
        }
        console.log('Menú final:', this.menuItems);

        // Refresh the cached roles after navigating within an application.
        if (this.activeRoute.includes('/apps')) {
          const parts = this.activeRoute.split('/');
          this.currentProjectId = parts[1];

          console.log('Project ID:', this.currentProjectId);
          this.authRoleService.reloadRoles();
          this.checkRoles();
        }

      }
    });
  }



  menuItems: MenuItem[] = [
    {
      icon: 'home',
      iconType: 'mat',
      label: 'IO Test',
      route: "/"

    },


  ];

  toggleSidebar() {
    this.sidebarToggle.emit();
  }



  onSidebarToggle() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }
  private checkRoles() {
    if (this.currentProjectId) {
      const roles = this.authRoleService.getRoles();
      console.log(`Roles for ${this.currentProjectId}:`, roles);
    }
  }
}